export function sanitizeHtml(html) {
  const safe = typeof html === "string" ? html : "";
  if (!safe) return "";
  const fallback = safe
    // remove disallowed block tags and self-closing variants
    .replace(
      /<(script|style|img|video|iframe|object|embed|link|meta|svg|math|form)[^>]*>[\s\S]*?<\/\1>/gi,
      "",
    )
    .replace(
      /<(script|style|img|video|iframe|object|embed|link|meta|svg|math|form)[^>]*\/>/gi,
      "",
    )
    // strip inline style attributes in fallback path
    .replace(/\sstyle\s*=\s*("[^"]*"|'[^']*')/gi, "");
  try {
    if (
      typeof window === "undefined" ||
      typeof window.DOMParser === "undefined"
    )
      return fallback;
    const parser = new window.DOMParser();
    const doc = parser.parseFromString(safe, "text/html");
    // Extend forbidden list to cover common active/embedded vectors.
    const forbidden = [
      "script",
      "style",
      "img",
      "video",
      "iframe",
      "object",
      "embed",
      "link",
      "meta",
      "svg",
      "math",
      "form",
    ];
    forbidden.forEach((tag) => {
      doc.querySelectorAll(tag).forEach((node) => node.remove());
    });
    doc.querySelectorAll("*").forEach((node) => {
      Array.from(node.attributes).forEach((attr) => {
        if (/^on/i.test(attr.name)) node.removeAttribute(attr.name);
        // Drop all inline styles to avoid CSS-based vectors (incl. url()).
        if (attr.name.toLowerCase() === "style")
          node.removeAttribute(attr.name);
      });
      if (node.tagName && node.tagName.toLowerCase() === "a") {
        const href = node.getAttribute("href") || "";
        // allow only http, https, mailto, and hash anchors
        if (!href.match(/^(https?:|mailto:|#)/i)) node.removeAttribute("href");
        else {
          node.setAttribute("rel", "noopener");
          node.setAttribute("target", "_blank");
        }
      }
    });
    return doc.body.innerHTML;
  } catch (e) {
    return fallback;
  }
}

export function stripHtml(html) {
  if (!html) return "";
  try {
    if (typeof window !== "undefined" && window.DOMParser) {
      const parser = new window.DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      return doc.body.textContent || "";
    }
  } catch (e) {}
  return (html || "").replace(/<[^>]*>/g, "");
}
